export default class userinfo {
    id: number;
    userName: string;
    name: string;
    recordId: number;
}